module.exports = __webpack_public_path__ + "img/profile_box_coach_type.ce188ed9.svg";